export const TRANSACTION_TYPE_FAILED = 'FAILED'
export const TRANSACTION_TYPE_COMPLETED = 'COMPLETED'
export const TRANSACTION_TYPE_PENDING = 'PENDING'